<template>
  <cube-page :title="title">
    <div slot="content">
      <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
        <el-tab-pane label="全年进度排名" name="top">
        </el-tab-pane>
        <el-tab-pane label="明细数据" name="detail">
        </el-tab-pane>
      </el-tabs>
      <wmq-layout
      v-show="activeName === 'top'"
      ref="top"
      :rootLayoutConfig="topUiConfig" />
      <wmq-layout
        v-show="activeName === 'detail'"
        ref="detail"
        :rootLayoutConfig="detailConfig" />
    </div>
  </cube-page>
</template>

<script>
import uiConfig from '@/config/ui-config/product-distribution-by-province-detail-ui-config'
import topUiConfig from '@/config/ui-config/product-distribution-by-province-top-ui-config'
import { biData } from '@/api/cube'
import { WmqDashboardCubeDataHelperMixin, CubeDataHandle } from 'wmq-component'
import { get, has, isEmpty, set } from 'lodash'
import CubePage from '../../components/cube-page'

export default {
  name: 'ProductDistributionByProvince',
  components: { CubePage },
  mixins: [WmqDashboardCubeDataHelperMixin],
  data () {
    return {
      activeName: 'top',
      topUiConfig
    }
  },
  mounted () {
    this.$refs[this.activeName].refreshAll()
  },
  computed: {
    detailConfig () {
      const height = document.body.clientHeight - 100
      console.log('height', height)
      set(uiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return uiConfig
    },
    title() {
      return get(this.$route, 'query.channelType', '') + '铺货'
    }
  },
  provide () {
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        if (has(reqObj, 'year') && isEmpty(get(reqObj, 'year'))) {
          reqObj.year = that.$route.query.year
        }
        reqObj.channelType = that.$route.query.channelType
        reqObj.productBrand = that.$route.query.productBrand
        return biData(data.dataCode, reqObj).then(res => {
          return new Promise((resolve) => {
            resolve(CubeDataHandle.handleCubeData(res.data))
          })
        })
      }
    }
  },
  methods: {
    handleClick () {
      this.$refs[this.activeName].refreshAll()
    }
  }
}
</script>

<style scoped>

</style>
